import { render, staticRenderFns } from "./ParticipantAssignment.vue?vue&type=template&id=0f637e74&scoped=true&"
import script from "./ParticipantAssignment.vue?vue&type=script&lang=ts&"
export * from "./ParticipantAssignment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f637e74",
  null
  
)

export default component.exports